module.exports = __webpack_public_path__ + "static/media/lock.2a71d63f.svg";